import { useLocation } from "react-router-dom";
import { useLayoutEffect } from "react";

export function navToGitHub() {
    window.open("https://github.com/maxtbuchholz", "gitHub");
}
export function startEmail() {
    window.open("mailto:maxtbuchholz@gmail.com", "email");
    // window.open("mailto:maxtbuchholz@gmail.com", "email");
    // window.location.href = "mailto:user@example.com?subject=Subject&body=message%20goes%20here";
}
export function scrollToInstant(name){
    if(name != null){
    if(name === "home"){
        name = "top";
    }
    var element = document.getElementById(name);
    var container = document.getElementById("sectionContainer");
    if((element != null) && (container != null)){
        // element.scrollIntoView({ behavior: "smooth" });
        container.scrollTo({
            top: element.offsetTop - 100,
            behavior: "instant"
          });
    }
}
}

// easing functions http://goo.gl/5HLl8
Math.easeInOutQuad = function (t, b, c, d) {
    t /= d/2;
    if (t < 1) {
      return c/2*t*t + b
    }
    t--;
    return -c/2 * (t*(t-2) - 1) + b;
  };
Math.easeInCubic = function(t, b, c, d) {
    var tc = (t/=d)*t*t;
    return b+c*(tc);
  };
Math.inOutQuintic = function(t, b, c, d) {
    var ts = (t/=d)*t,
    tc = ts*t;
    return b+c*(6*tc*ts + -15*ts*ts + 10*tc);
  };
export function scrollTo(target, callback, duration) {
  window.open(`/${target}`,"_self");
  }